
import 'core-js/es6/symbol';
import 'core-js/fn/array/from';
import 'core-js/fn/number/is-finite';
import 'core-js/fn/reflect';
import 'core-js/fn/symbol/iterator.js';
import "core-js/fn/array/flat-map";
import 'core-js/es7/object';

import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import VueApexCharts from 'vue-apexcharts';
import Cleave from 'vue-cleave-component';
import RadialProgressBar from 'vue-radial-progress'
import store from '../store/store';
import router from '../routes/routes'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import { BootstrapVue } from "bootstrap-vue";
import App from './App.vue';
import vSelect from 'vue-select';
import 'bootstrap';
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/scss/main.scss";
import './util/vueFilters';
import "./plugins/element-ui";

import VCalendar from 'v-calendar-ie11';

window.$ = require('jquery')
window.JQuery = require('jquery')

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.component('paginate', Paginate);
Vue.component('multiselect', Multiselect);
vSelect.props.components.default = () => ({
    Deselect: {
      render: createElement => createElement('i',  {class: {'fas fa-times': true}}),
    },
    OpenIndicator: {
      render: createElement => createElement('i',  {class: {'fas fa-caret-down': true}}),
    },
});
Vue.component('v-select', vSelect);

Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.use(Cleave);
import vueCleave from "cleave.js";
const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input');
    input._vCleave = new vueCleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector('input');
    input._vCleave.destroy();
  },
};
Vue.directive('cleave', cleave);
Vue.component('radial-progress-bar', RadialProgressBar);
Vue.use(BootstrapVue);

// Analytics
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-76091434-4',
  autoTracking: {
    exception: true
  }
});

Vue.config.productionTip = false;

axios.interceptors.request.use(function(config) {
    if (config.method === 'get') {
        let params = config.params || {};
        params.cache = new Date().getTime();
        config.params = params;
    }
    return config;
},
function(err) {
    return Promise.reject(err);
});

// Add a 401 interceptor. So when any requests come back with 401 (unauthorized), we log the user out.
axios.interceptors.response.use((response) => {
    return response;
  },
  function(err) {
    if (err.response.status === 401) {
        console.dir(store);
        store.dispatch('login/logUserOut')
        router.push('/logoutSuccessful');
    }

    return Promise.reject(err);
  });

new Vue(Vue.util.extend({ store,router }, App)).$mount('#app');
